import React, { useEffect, useMemo } from 'react'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'

import { useGrowthBook } from '@growthbook/growthbook-react'

import { Spinner } from 'components/Spinner'

import { selectUUID } from 'root-redux/selects/user'

import { useABTest } from 'hooks/useABTest'

import { getCurrentEnv } from 'helpers/getCurrentEnv'

import { TPageProps } from 'models/common.model'

import { eventLogger } from 'services/eventLogger.service'

import { PageId } from 'page-constants'
import { Cohort, CurrentEnvironment } from 'root-constants'

import {
  Domain,
  FUNNEL_LAB_COHORT,
  FUNNEL_LAB_COHORT_FIRST_PAGE,
  PROD_LINKS,
  STAGE_LINKS,
} from './constants'

export const ProviderAppVsBuilder: React.FC<TPageProps> = () => {
  const uuid = useSelector(selectUUID)
  const { search } = useLocation()

  const growthbook = useGrowthBook()

  const { isFunellabCohortActive } = useABTest()
  const currentEnv = getCurrentEnv()
  const isProdEnvironment = currentEnv === CurrentEnvironment.PROD

  const redirectLink = useMemo(() => {
    const params = new URLSearchParams(search)

    if (!uuid || !growthbook || !growthbook.ready) return ''

    const domain = isFunellabCohortActive ? Domain.BUILDER : Domain.APP
    const domainLink = isProdEnvironment
      ? PROD_LINKS[domain]
      : STAGE_LINKS[domain]

    const firstPage = isFunellabCohortActive
      ? FUNNEL_LAB_COHORT_FIRST_PAGE
      : PageId.INTRO_REFUND

    const cohort = isFunellabCohortActive ? FUNNEL_LAB_COHORT : Cohort.LUVLY_REF

    params.set('cohort', cohort)

    return `${domainLink}${firstPage}?${params.toString()}`
  }, [growthbook, isFunellabCohortActive, isProdEnvironment, search, uuid])

  useEffect(() => {
    if (!uuid) return
    eventLogger.logPreloadingCompleted()
  }, [uuid])

  useEffect(() => {
    if (!redirectLink) return

    setTimeout(() => {
      window.location.href = redirectLink
    }, 1000)
  }, [redirectLink])

  return <Spinner />
}
